module.exports = new __parcel__URL__("layouts/App.css").toString();